<template>
  <div class="loan-record-wrap">
    <loan-search v-model="search" @query="getLoanData" @reset="getLoanData" />
    <header-title title="查询结果" />
    <div class="num-wrap">
      <el-row>
        <el-col :span="6">
          <span class="label">冻结中挂牌商品履约金：</span>
          <span class="value">{{ loanData.freezing }}</span>
        </el-col>
        <el-col :span="6" class="center">
          <span class="label">历史总冻结挂牌商品履约金：</span>
          <span class="value">{{ loanData.totalFreeze }}</span>
        </el-col>
        <el-col :span="6" class="right">
          <span class="label">历史总解冻：</span>
          <span class="value">{{ loanData.totalThaw }}</span>
        </el-col>
        <el-col :span="6" class="right">
          <span class="label">可用挂牌商品履约金：</span>
          <span class="value">{{ thawedQuantity }}</span>
        </el-col>
      </el-row>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" stripe v-loading="loading" key="delivery">
        <el-table-column label="流水号" prop="pipelineCode" />
        <el-table-column label="交易时间" prop="dealDate" />
        <el-table-column label="操作方向" prop="type">
          <template slot-scope="scope">
            {{ scope.row.type === '0' ? '冻结' : '解冻' }}
          </template>
        </el-table-column>
        <el-table-column label="冻结金额" prop="amount" />
        <el-table-column label="业务单据号" prop="businessCode" />
        <el-table-column label="源流水号" prop="pipelineCodeRel" />
        <el-table-column label="摘要" prop="remark" />
      </el-table>
      <div class="pagination-wrapper">
        <pagination :data="pageData" @retrieve="getLoanData" />
      </div>
    </div>
  </div>
</template>

<script>
import loanSearch from './LoanSearch'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('framework')

export default {
  name: 'LoanRecord',
  components: {
    loanSearch
  },
  data () {
    return {
      search: {}, // 搜索
      tableData: [], // 表格数据
      pageData: [], // 分页数据
      pageSize: 10,
      currentNo: 1,
      thawedQuantity: '', // 可用挂牌商品履约金
      loanData: {
        freezing: '',
        totalFreeze: '',
        totalThaw: '',
      }, // 货款合计信息
      loading: false
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo',
    }),
  },
  watch: {
    userInfo: { // 登录信息改变的时候刷新数据
      handler () {
        this.getLoanData(1)
        this.getTotalLoan()
        this.getFreezingQuantity()
      },
      deep: true
    }
  },
  mounted () {
    this.getTotalLoan()
    this.getFreezingQuantity()
  },
  methods: {
    // 获取表格数据
    getLoanData (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.loading = true
      this.currentNo = currentNo || this.currentNo || 1
      const url = this.$API.loanRecord.retrieve
      const param = this.$utils.objectAssign({}, this.search, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
        sortType: this.sortType
      })
      this.$http.post(url, param).then(res => {
        this.tableData = res.data.rows
        this.pageData = res.data
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.pageData = {}
        this.loading = false
      })
    },
    // 获取未冻结余额
    getFreezingQuantity () {
      const url = this.$API.releaseQuotation.queryUserErpAccount
      this.$http.post(url, {}).then(res => {
        this.thawedQuantity = res.data.amount
      })
    },
    // 获取货款合计
    getTotalLoan () {
      const url = this.$API.loanRecord.totalLoanPC
      this.$http.post(url, {}).then(res => {
        this.loanData = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .loan-record-wrap{
    .num-wrap{
      margin-top: -3px;
      margin-bottom: 24px;
      .label {
        font-size: 18px;
        color: rgba(51,51,51,0.94);
        font-weight: bold;
      }
      .value{
        font-size: 18px;
        color: #ff7f00;
      }
      .center{
        text-align: center;
      }
      .right{
        text-align: right;
      }
    }
  }
</style>
